import { Component } from '@angular/core';
import { MatSnackBarRef } from '@angular/material/snack-bar';

@Component({
    template: `
        <div fxFlexLayout="column">
            <h3>You're all set.</h3>
            <h4>We've sent an email with a link to sign in</h4>
        </div>
        <div>
            <button mat-button (click)="snackBarRef.dismiss()">Close</button>
        </div>
`})
export class MagicLinkSentSnackbarMessageComponent {
    constructor(public snackBarRef: MatSnackBarRef<MagicLinkSentSnackbarMessageComponent>) { }
}
